import { type ButtonHTMLAttributes } from 'react';
import classnames from 'classnames';

type TButtonLinkProps = ButtonHTMLAttributes<HTMLButtonElement>;

export default function ButtonLink({ onClick, children, className, ...rest }: TButtonLinkProps) {
  return (
    <button type="button" className={classnames('link', className)} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}
